import { DataService } from "./data.service";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Url } from "../common/url";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class VisitService extends DataService {
  constructor(
    http: HttpClient,
    private localHttp: HttpClient,
    private authService: AuthService
  ) {
    super("visit", http);
  }

  url: string = Url.visit;

  getAllResources(
    requestType: string,
    orderDone?: boolean,
    isReminder?: boolean,
    powertrainId?: string,
    motorId?: string,
    orderDoneReviewed?: boolean,
    isVisitReviewed?: boolean,
    skip: number = 0,
    limit: number = 25,
    dateFrom: Date = null,
    dateTo: Date = null
  ) {
    let fields = `&filter[fields]=date&filter[fields]=time&filter[fields]=hoursread&filter[fields]=prevhoursread&filter[fields]=requestType&filter[fields]=reminder&filter[fields]=orderNumber&filter[fields]=orderHour&filter[fields]=prevOrderHour&filter[fields]=notes&filter[fields]=start&filter[fields]=end&filter[fields]=supervisor&filter[fields]=generatorNumber&filter[fields]=reviewed&filter[fields]=orderDoneReviewed&filter[fields]=orderDone&filter[fields]=accountId&filter[fields]=orderDoneBy&filter[fields]=orderDoneReviewedBy&filter[fields]=reviewerId&filter[fields]=powertrainId&filter[fields]=motorId&filter[fields]=workshopId&filter[fields]=orderGeneratedDate&filter[fields]=visitId&filter[fields]=created&filter[fields]=updated&filter[fields]=isOrderGeneratedFromVisit&filter[fields]=id`;
    let reqType = requestType
      ? "?filter[where][requestType]=" + requestType + "&"
      : "?";
    let ptId =
      powertrainId && powertrainId != "null"
        ? "&filter[where][powertrainId]=" + powertrainId
        : "";
    let engId =
      motorId && motorId != "null" ? "&filter[where][motorId]=" + motorId : "";
    let oDoneReviewed = orderDoneReviewed
      ? "&filter[where][orderDoneReviewed]=true"
      : "";
    let remind = isReminder ? "&filter[where][reminder][gt]=0" : "";
    let filterInclude =
      "&filter[include]=powertrain&filter[include]=motor&filter[include]=addedBy&filter[include]=workshop&filter[include]=reviewedBy&filter[order]=id DESC";
    let isReviewed = isVisitReviewed ? "&filter[where][reviewed]=true" : "";
    let oDone: string;
    let dateSearch =
      dateFrom && dateTo
        ? `&filter[where][date][between][0]=${dateFrom}&filter[where][date][between][1]=${dateTo}`
        : "";
    let fDate =
      dateFrom && !dateTo ? `&filter[where][date][gt]=${dateFrom}` : "";
    let tDate = dateTo && !dateFrom ? `&filter[where][date][lt]=${dateTo}` : "";
    let limit25 = `&filter[limit]=${limit}&filter[skip]=${skip}`;
    let limitGreaterThan25 = `&filter[limit]=${limit}&filter[skip]=${skip}&filter={"fields":${fields}}`;
    let filterLimit = limit <= 25 ? limit25 : limitGreaterThan25;
    if (requestType == "order") {
      if (oDoneReviewed) {
        oDone = orderDone
          ? "&filter[where][orderDone]=true"
          : "&filter[where][orderDone]=false";
      } else {
        const odReview =
          this.authService.isAdmin() ||
          this.authService.isGeneralManager() ||
          this.authService.isManager()
            ? ""
            : "&filter[where][orderDoneReviewed][neq]=true";
        oDone = orderDone
          ? "&filter[where][orderDone]=true" + odReview
          : "&filter[where][orderDone]=false";
      }
    } else {
      oDone = orderDone ? "&filter[where][orderDone]=true" : "";
    }
    return this.localHttp.get(
      this.url +
        reqType +
        isReviewed +
        ptId +
        engId +
        oDone +
        oDoneReviewed +
        filterInclude +
        remind +
        fDate +
        tDate +
        dateSearch +
        filterLimit
    );
  }

  getAllResourcesCount(
    requestType: string,
    orderDone?: boolean,
    isReminder?: boolean,
    powertrainId?: string,
    motorId?: string,
    orderDoneReviewed?: boolean,
    isVisitReviewed?: boolean,
    dateFrom: Date = null,
    dateTo: Date = null
  ) {
    let reqType = requestType
      ? "?where[requestType]=" + requestType + "&"
      : "?";
    let ptId =
      powertrainId && powertrainId != "null"
        ? "&where[powertrainId]=" + powertrainId
        : "";
    let engId =
      motorId && motorId != "null" ? "&where[motorId]=" + motorId : "";
    let oDoneReviewed = orderDoneReviewed
      ? "&where[orderDoneReviewed]=true"
      : "";
    let remind = isReminder ? "&where[reminder][gt]=0" : "";
    let isReviewed = isVisitReviewed ? "&where[reviewed]=true" : "";
    let oDone: string;
    let dateSearch =
      dateFrom && dateTo
        ? `&where[date][between][0]=${dateFrom}&where[date][between][1]=${dateTo}`
        : "";
    let fDate = dateFrom && !dateTo ? `&where[date][gt]=${dateFrom}` : "";
    let tDate = dateTo && !dateFrom ? `&where[date][lt]=${dateTo}` : "";

    if (requestType == "order") {
      if (oDoneReviewed) {
        oDone = orderDone
          ? "&where[orderDone]=true"
          : "&where[orderDone]=false";
      } else {
        const odReview =
          this.authService.isAdmin() ||
          this.authService.isGeneralManager() ||
          this.authService.isManager()
            ? ""
            : "&where[orderDoneReviewed][neq]=true";
        oDone = orderDone
          ? "&where[orderDone]=true" + odReview
          : "&where[orderDone]=false";
      }
    } else {
      oDone = orderDone ? "&where[orderDone]=true" : "";
    }
    return this.localHttp.get(
      `${this.url}/count` +
        reqType +
        isReviewed +
        ptId +
        engId +
        oDone +
        oDoneReviewed +
        remind +
        fDate +
        tDate +
        dateSearch
    );
  }

  getOrderDetails(orderNumber) {
    return this.localHttp.get(
      `${this.url}?filter[where][orderNumber]=${orderNumber}`
    );
  }

  getEngineLastVisitHour(engineId: string) {
    return this.localHttp.get(
      this.url +
        "?filter[where][motorId]=" +
        engineId +
        "&filter[where][hoursread][neq]=null&filter[limit]=2&filter[order]=hoursread DESC"
    );
  }

  getEngineLastOrderHour(engineId: string) {
    return this.localHttp.get(
      this.url +
        "?filter[where][motorId]=" +
        engineId +
        "&filter[where][orderDone]=true&filter[limit]=1&filter[order]=id DESC"
    );
  }

  getUnDoneOrdersCount() {
    return this.localHttp.get(
      this.url + "/count?where[requestType]=order&where[orderDone]=false"
    );
  }

  getDoneOrdersCount() {
    return this.localHttp.get(
      this.url + "/count?where[requestType]=order&where[orderDone]=true"
    );
  }

  getReminderedOrdersCount() {
    return this.localHttp.get(
      this.url +
        "/count?where[requestType]=order&where[orderDone]=false&where[reminder][gt]=0"
    );
  }

  getByVisitId(visitId: string) {
    return this.localHttp.get(this.url + "?filter[where][visitId]=" + visitId);
  }

  getEngineLastOrderDetails(engineId: string) {
    return this.localHttp.get(
      this.url +
        "?filter[where][motorId]=" +
        engineId +
        "&filter[where][requestType]=order&filter[limit]=1&filter[order]=id DESC"
    );
  }

  getVisitOrder(visitId: string) {
    return this.localHttp.get(
      this.url +
        "?filter[where][visitId]=" +
        visitId +
        "&filter[where][requestType]=order&filter[limit]=1&filter[order]=id DESC"
    );
  }

  cancelChanges(visit: any) {
    visit.reviewed = false;
    visit.reviewerId = null;
    return this.localHttp.put(this.url + "/" + visit.id, visit);
  }

  deleteOrder(id: any) {
    return this.localHttp.delete(this.url + "/" + id);
  }

  cancelOrder(orderId: string) {
    let data: any = {};
    data.orderDoneReviewed = null;
    data.orderGeneratedDate = null;
    data.date = null;
    data.end = null;
    data.hoursread = null;
    data.orderDoneBy = null;
    data.orderDone = false;
    return this.localHttp.put(this.url + "/" + orderId, data);
  }
}
